// 무빈소 퍼널 B안 랜딩 화면 데이터.
// 네이버 SA 특정 소재 유입 시 노출되는 후기 + 영상 정보.

export const LANDING_B_REVIEWS = [
  {
    html: "무빈소 장례를 통해 <b>가족들끼리 깊은 추모의 시간</b>을 가져 오히려 후회 없는 선택이었습니다.",
    author: "박OO",
    date: "2026.08",
  },
  {
    html: "처음엔 걱정했는데, 고이에서 <b>절차부터 비용까지 꼼꼼하게</b> 안내해주셔서 안심하고 진행했습니다.",
    author: "김OO",
    date: "2026.07",
  },
  {
    html: "빈소 없이도 <b>충분히 의미 있는 장례</b>를 치를 수 있다는 걸 알게 되었어요. 감사합니다.",
    author: "이OO",
    date: "2026.06",
  },
  {
    html: "비용 부담이 줄어서 좋았고, <b>장례지도사분이 처음부터 끝까지</b> 함께해주셔서 든든했어요.",
    author: "최OO",
    date: "2026.05",
  },
  {
    html: "가족장으로 <b>조용하고 편안하게</b> 보내드릴 수 있었습니다. 무빈소를 선택하길 잘했어요.",
    author: "정OO",
    date: "2026.04",
  },
] as const;

export const LANDING_B_VIDEO = {
  youtubeId: "w9UwOUhjBAQ",
  duration: "10:56",
  caption: "고이 장례지도사의 무빈소 장례 현장",
} as const;
